export default __webpack_public_path__ + "static/media/s4_golf_cart_transition.92554670.riv";